import agentforgeHttp from '@/lib/agentforge-http';

export const axiosAgentforgeQuery =
  () =>
  async ({
    url,
    method = 'get',
    params = null,
    data = null,
  }: {
    url: string;
    method?: string;
    params?: Record<string, any> | null;
    data?: any;
  }) => {
    try {
      // agentforgeHttp has a response interceptor that returns response.data,
      // so the result is the JSON body (not an AxiosResponse).
      const result = (await agentforgeHttp({
        url,
        method,
        params,
        data,
      })) as any;
      // auth-interceptor can resolve 4xx as data (Promise.resolve) with injected status.
      // Detect and return as error so RTK Query doesn't cache stale data.
      if (result?.status >= 400) {
        return { error: { status: result.status, data: result } };
      }
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data,
        },
      };
    }
  };
